module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochd"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Images",
      "src": "images/head.jpg"
    }
  }), _vm._v(" Table of Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Editors"
    }
  }, [_vm._v("Editors’ Note")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Foreword#aut1"
    }
  }, [_vm._v("Michael Kraus")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter1"
    }
  }, [_vm._v("Photographing Monuments")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter1#aut2"
    }
  }, [_vm._v("Chris Heisey")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter2"
    }
  }, [_vm._v("“Fame” at Shiloh")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter2#aut3"
    }
  }, [_vm._v("Chris Mackowski")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter3"
    }
  }, [_vm._v("What is a Monument?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter3#aut4"
    }
  }, [_vm._v("Kristopher D. White")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Birth of the Battlefield Preservation Movement")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter4#aut5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary Koik")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“The Day Long Remembered”: Remembering Bull Run")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter5#aut6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anthony Trusso")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Field of Heaviest Losses” at Cold Harbor")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter6#aut7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phillip S. Greenwalt")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Cause” for Confusion: Monumental Intent at Gettysburg")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter7#aut8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dan Welch")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Contested Origins of Gettysburg’s Virginia Monument")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter8#aut9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jonathan Tracey")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Albert Sidney Johnston Stumped at Shiloh")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter9#aut10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chris Mackowski")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confederate Monuments, Southern Memory")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10#aut11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stephen Davis")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Reminder of Compromise and Controversy")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11#aut12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jon-Erik Gilot")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moving Memory: Virginia Military Institute’s Stonewall Jackson Statue")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12#aut13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sarah Kay Bierle")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confederate Monuments in Massachusetts: Who Knew?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13#aut14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rob Wilson")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Not to Prolong the Animosities Engendered by the War”: The Story Behind the Alexandria Statue, “Appomattox”")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14#aut15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mark Maloy")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emancipation Memorial, Lincoln Park, Washington, D.C.")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15#aut16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steward T. Henderson")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When a Monument Gets Its History Wrong")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16#aut17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chris Mackowski")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hideous Forrest")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17#aut18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meg Groeling")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("History, Heritage, and Hate: The Fate of Confederate Monuments in My Ancestral Home")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18#aut19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David T. Dixon")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("History vs. Memory: Statues of Stonewall Offer a Lesson")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter19#aut20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chris Mackowski")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Grave Dilemma: What to Do with A.P. Hill?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter20#aut21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frank Jastrzembski")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honoring General Milton S. Littlefield: The Right Thing to Do?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter21#aut22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frank Jastrzembski")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paying My Respects to a “Bad, Old” Opponent")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter22#aut23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chris Mackowski")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“A Reservoir of Misinformation”: Early Signs of the Lost Cause at Fort Gregg")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter23#aut24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward Alexander")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Company Against Two Corps")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter24#aut25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stephen Davis")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Civil War Myth Busting: The Fictional Confederate Irish Brigade at Fredericksburg")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter25#aut26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ryan T. Quint")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Bridge for Whiskey: The 51st Pennsylvania and Its Famous Request Examined")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter26#aut27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kevin Pawlak")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ellis Spear 1913 Does Not Jive with Ellis Spear 1863")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter27#aut28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brian Swartz")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“So Full of Gross Error that I am Surprised at its Publication”: Disputed Memories at Gettysburg")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter28#aut29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jonathan Tracey")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Granger’s Juneteenth Orders and the Limiting of Freedom")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter29#aut30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward Alexander")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Impartial Account of War and Memory: The Public and Private Recollections of Confederate General Edward Porter Alexander")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter30#aut31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abbi Smithmyer")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Most Overlooked Phase of the Overland Campaign")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter31#aut32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chris Mackowski")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memorial to the California Column")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter32#aut33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philip S. Greenwalt")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanishing Monuments: The Case of Custer City, Colorado")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter33#aut34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cecily Nelson Zander")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugar Kettle Art: Accidental Monuments")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter34#aut35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sheritta Bitikofer")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Immortal” General Sherman")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter35#aut36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David T. Dixon")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grand Old Men: The Last Veterans and Civil War Memory in the Mid-Twentieth Century")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter36#aut37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brian Matthew Jordan")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Being Grant: Now and Then")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter37#aut38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curt Fields")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robert Penn Warren, Jefferson Davis, and the Construction of a Monument")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter38#aut39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chris Mackowski")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Contributors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors’ Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Postscript",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript: “The Ballad of Black Bess”")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Postscript#aut40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stephen Davis")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 75
// module chunks = 0